export const TENANT_STATUS = {
    ARCHIVED: "Archived",
    ACTIVE: "Active",
    CREATION_IN_PROGRESS: "CreationInProgress"
};

export const TENANT_TYPE = {
    RAPID_REUNIFICATION: "RapidReunification",
    MERRGE_211: "Merrge211"
};